import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Stack,
    Typography,
} from "@mui/material"
import { ReactElement, ReactNode } from "react"

import { STATUS_DISPATCHER } from "./installerSingleApplicationStatusTypes"
import { InstallerApplicationStatuses } from "../../constants/enums"
import { UNKNOWN_STATUS } from "../../constants/generalConstants"
import AppAlert from "../dataDisplay/alerts/appAlert"
import { AppCardHeader } from "../surfaces/appCard"
import DisplayIf from "../wrappers/displayIf"

type StatusProps = {
    status: InstallerApplicationStatuses | string
    dnoComments: string
    cxRef: boolean
    condition: boolean
    children?: ReactNode
    dno: string
}

export const FONT_VARIANT = "h5"
export const FONT_WEIGHT = "500"

/**
 * Renders the status of a single installer application.
 * It also renders the DNO comments if the condition is met.
 */
const InstallerSingleApplicationStatus = ({
    status,
    dno,
    dnoComments,
    cxRef,
    condition,
    children = null,
}: StatusProps): ReactElement => {
    const statusInfo =
        STATUS_DISPATCHER(dno)[status as InstallerApplicationStatuses] ||
        STATUS_DISPATCHER("")[UNKNOWN_STATUS]

    if (status === UNKNOWN_STATUS) {
        statusInfo.status = status
    }

    return (
        <AppAlert severity={statusInfo.alertSeverity} icon={false}>
            <Stack>
                <AppCardHeader
                    avatar={statusInfo.statusIcon}
                    title={status}
                    subheader={
                        <Typography>
                            {statusInfo.statusMessage}
                            <DisplayIf condition={cxRef}>
                                <>
                                    <br />
                                    <br />
                                    Once the installation is complete, please
                                    provide commissioning information
                                </>
                            </DisplayIf>
                        </Typography>
                    }
                    titleTypographyProps={{
                        variant: FONT_VARIANT,
                        fontWeight: FONT_WEIGHT,
                    }}
                />
            </Stack>
            {children}
            <DisplayIf condition={condition}>
                <Accordion sx={{ boxShadow: "none" }}>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                        <Typography fontWeight={FONT_WEIGHT}>
                            Click here to see comments left by {dno}!
                        </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>{dnoComments}</Typography>
                    </AccordionDetails>
                </Accordion>
            </DisplayIf>
        </AppAlert>
    )
}

InstallerSingleApplicationStatus.defaultProps = {
    children: null,
}

export default InstallerSingleApplicationStatus
